<template>
  <div class="dashboard">
    <h1>Dashboard</h1>
    <h2 v-if="mileageAnalysis.length > 0">Kilometers gereden</h2>
    <p v-else>Kilometer analyse wordt geladen...</p>
    <chart :data="mileageAnalysis"></chart>
    <h2 v-if="fuelAnalysis.length > 0">Liters getankt</h2>
    <p v-else>Benzine analyse wordt geladen...</p>
    <chart :data="fuelAnalysis"></chart>
  </div>
</template>

<script>

import Chart from './Chart.vue';

export default {
  name: 'Dashboard',
  components:{
    'chart': Chart
  },
  data () {
    return {
      mileageAnalysis: [],
      fuelAnalysis: []
    }
  },
  methods: {
    getMileageAnalysis() {
      const token = localStorage.getItem('token');

      this.axios.get(this.config.api + '/mileage/analysis', {
        headers: {
          authorization: token
        }
      })
      .then(result => {
        this.mileageAnalysis = result.data
          .map(data => {
            return {
              label: data.userName,
              key: data.userId,
              value: data.distance,
              colour: data.colour
            }
          })
          .sort((a, b) => a.label > b.label ? 1 : -1)
      })
    },
    getFuelAnalysis() {
      const token = localStorage.getItem('token');

      this.axios.get(this.config.api + '/fuel/analysis', {
        headers: {
          authorization: token
        }
      })
      .then(result => {
        this.fuelAnalysis = result.data
          .map(data => {
            return {
              label: data.userName,
              key: data.userId,
              value: data.liters,
              colour: data.colour
            }
          })
          .sort((a, b) => a.label > b.label ? 1 : -1)
      })
    }
  },
  mounted() {
    this.global.GetBaseView().endLoad();
  },
  created() {
    this.getMileageAnalysis();
    this.getFuelAnalysis();
  }
}
</script>

<style scoped>

.dashboard {
  padding: 10px;

  margin: 0 0 60px 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue